var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33335 7.99992H7.00002L7.66669 5.33325H5.33335V3.99992C5.33335 3.31325 5.33335 2.66659 6.66669 2.66659H7.66669V0.426585C7.44935 0.397919 6.62869 0.333252 5.76202 0.333252C3.95202 0.333252 2.66669 1.43792 2.66669 3.46659V5.33325H0.666687V7.99992H2.66669V13.6666H5.33335V7.99992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fae4ec022a52ef864204be7102071306.svg";
export { ForwardRef as ReactComponent };